module.exports = __webpack_public_path__ + "static/oliva-5293934d7c62bec7d5d478d4cc9a2c70.jpg";